{
  "intro": "Virtual machines of this Hetzner project. A server is billed by the hour from creation until it is deleted, also while it is switched off. Open a server to power it, rebuild it, resize it or watch its load.",
  "detailIntro": "Everything about this one server: its addresses, power, rescue system, operating system, size, backups and load. Changes run at Hetzner in the background; the progress shows here.",
  "create": "Create server",
  "empty": "No servers yet",
  "emptyLead": "A server is a virtual machine with its own public address. Pick a size, a location and an operating system; it is ready in about a minute and billed by the hour until you delete it.",
  "filter": "Filter servers",
  "filterPlaceholder": "Name or IP address",
  "statusFilter": "Status",
  "anyStatus": "Any status",
  "noMatch": "No server matches the filter.",
  "name": "Name",
  "nameHint": "Becomes the server's hostname: letters, digits, dots and hyphens, up to 63 characters.",
  "nameInvalid": "Use letters, digits, dots and hyphens; start and end with a letter or digit.",
  "statusColumn": "Status",
  "publicIp": "Public address",
  "privateIp": "Private IP",
  "noIpv4": "IPv6 only",
  "region": "Location",
  "created": "Created",
  "open": "Open",
  "actions": "Actions",
  "gb": "GB",
  "ipv4": "IPv4 address",
  "ipv6": "IPv6 network",
  "copy": "Copy {{what}}",
  "on": "On",
  "off": "Off",
  "powerSwitch": "Power",
  "notSwitchable": "Wait until the server is on or off.",
  "busy": "Another change is still running on this server. Wait until it finishes.",
  "notRunning": "Only while the server is running.",
  "notOff": "Only while the server is off.",
  "rename": "Rename",
  "renameLead": "The name is how you find the server here; the provider also sets it as the hostname of new installations.",
  "renamed": "Server renamed to “{{name}}”",
  "notFound": "Server not found",
  "notFoundLead": "This server does not exist in the project, or it was deleted.",
  "backToList": "Back to servers",
  "tabsLabel": "Server sections",
  "progress": "{{what}}… {{progress}}\u00a0%",
  "started": "{{what}}: started for “{{name}}”",
  "done": "{{what}}: done for “{{name}}”",
  "failed": "{{what}} failed for “{{name}}”. Open the server to see its state.",
  "noActivity": "Nothing has been done to this server through CloudServer yet.",
  "status": {
    "initializing": "Being created",
    "starting": "Starting",
    "running": "Running",
    "stopping": "Stopping",
    "off": "Off",
    "rebuilding": "Rebuilding",
    "migrating": "Moving",
    "deleting": "Being deleted",
    "unknown": "Unknown"
  },
  "activityStatus": {
    "running": "Running",
    "success": "Done",
    "error": "Failed"
  },
  "kinds": {
    "create": "Create",
    "update": "Rename or labels",
    "delete": "Delete",
    "power_on": "Power on",
    "shutdown": "Shut down",
    "power_off": "Power off",
    "reboot": "Reboot",
    "reset": "Reset",
    "enable_rescue": "Enable rescue",
    "disable_rescue": "Disable rescue",
    "reset_password": "Reset root password",
    "rebuild": "Rebuild",
    "change_type": "Change type",
    "enable_backups": "Enable backups",
    "disable_backups": "Disable backups",
    "create_snapshot": "Snapshot",
    "change_protection": "Change protection",
    "attach_iso": "Attach ISO",
    "detach_iso": "Detach ISO"
  },
  "tabs": {
    "overview": "Overview",
    "networking": "Networking",
    "power": "Power",
    "rescue": "Rescue",
    "rebuild": "Rebuild",
    "change-type": "Change type",
    "backups": "Backups & snapshots",
    "metrics": "Metrics",
    "autopilot": "Autopilot",
    "packages": "Apps",
    "app": "App",
    "alerts": "Alerts",
    "delete": "Delete",
    "iso": "ISO",
    "volumes": "Volumes"
  },
  "protection": {
    "badge": "Protected",
    "turnOn": "Turn protection on",
    "turnOff": "Turn protection off"
  },
  "overview": {
    "specs": "Configuration",
    "cores": "vCPU",
    "shared": "shared",
    "dedicated": "dedicated",
    "memory": "Memory",
    "disk": "Disk",
    "architecture": "Architecture",
    "image": "Operating system",
    "noImage": "Image no longer available",
    "region": "Location",
    "zone": "Network zone {{zone}}",
    "created": "Created",
    "backups": "Backups",
    "backupsOn": "Daily, window {{window}} UTC",
    "backupsOff": "Off",
    "iso": "Mounted ISO",
    "traffic": "Traffic this month",
    "trafficHint": "Outgoing traffic counts against the included volume; incoming traffic is free. Above the included volume each extra terabyte is billed.",
    "trafficUsed": "{{used}} of {{included}} included used (outgoing)",
    "trafficIn": "Incoming: {{value}} (not billed)",
    "activity": "Activity"
  },
  "labels": {
    "title": "Labels",
    "why": "Key–value tags you choose, e.g. env=production. Use them to find servers and to apply firewalls to groups of servers.",
    "none": "No labels.",
    "edit": "Edit labels",
    "lead": "One label per line, as key=value. A line without “=” is a label without a value.",
    "hint": "Keys and values: up to 63 characters, letters and digits at both ends, “-”, “_” and “.” inside.",
    "invalid": "A key or value is not allowed. Check the rules below the field.",
    "saved": "Labels saved"
  },
  "networking": {
    "public": "Public addresses",
    "noIpv4": "No public IPv4 address. The server is reachable over IPv6 only.",
    "reverseDns": "Reverse DNS",
    "reverseDnsHint": "The host name the address answers with in reverse lookups. Mail servers check it; set it on the IP addresses page.",
    "noReverseDns": "Not set",
    "ipv6Hint": "Every server gets a whole /64 network; the server uses the first address of it by default.",
    "noIpv6": "No IPv6 network.",
    "ipsElsewhere": "Addresses, reverse DNS and their protection are managed on the IP addresses page.",
    "private": "Private networks",
    "noPrivate": "Not attached to a private network.",
    "networkRef": "Network {{ref}}",
    "firewalls": "Firewalls",
    "noFirewalls": "No firewall is applied: every port the operating system opens is reachable.",
    "firewallRef": "Firewall {{ref}}"
  },
  "power": {
    "lead": "Shutting down asks the operating system to stop, like pressing the power button; powering off cuts the power at once. A server that is off is still billed — delete it to stop the costs.",
    "stillBilled": "A server that is off is still billed in full.",
    "power-on": {
      "action": "Power on",
      "explain": "Starts the server. It boots its operating system in a few seconds.",
      "started": "Starting “{{name}}”"
    },
    "shutdown": {
      "action": "Shut down",
      "explain": "Asks the operating system to stop cleanly (ACPI signal). Running programs can save their data. If the system ignores the signal, the server stays on.",
      "started": "Shutting down “{{name}}”",
      "confirmTitle": "Shut down “{{name}}”?",
      "consequence": "The operating system is asked to stop; services on the server become unreachable."
    },
    "power-off": {
      "action": "Power off",
      "explain": "Cuts the power at once, like pulling the plug. Data not yet written to the disk is lost. Use it when the system no longer reacts.",
      "started": "Powering off “{{name}}”",
      "confirmTitle": "Power off “{{name}}”?",
      "consequence": "The power is cut at once: data not yet written to the disk is lost."
    },
    "reboot": {
      "action": "Reboot",
      "explain": "Asks the operating system to restart cleanly. The server is unreachable for a short time.",
      "started": "Rebooting “{{name}}”",
      "confirmTitle": "Reboot “{{name}}”?",
      "consequence": "The operating system restarts; services are unreachable until it is back."
    },
    "reset": {
      "action": "Reset",
      "explain": "Restarts the server hard, without asking the operating system. Data not yet written to the disk is lost.",
      "started": "Resetting “{{name}}”",
      "confirmTitle": "Reset “{{name}}”?",
      "consequence": "The server restarts at once, like pressing reset: unsaved data is lost."
    }
  },
  "rescue": {
    "title": "Rescue system",
    "badge": "Rescue on",
    "lead": "A small Linux that starts from the network instead of the server's disk. Use it to repair a system that no longer boots or to recover files: the disk stays untouched and can be mounted from there.",
    "keys": "SSH keys for the rescue system",
    "noKeys": "No SSH keys in the project: you sign in with the root password shown after enabling.",
    "keysHint": "Chosen keys may sign in as root. A root password is generated as well.",
    "thenReboot": "The rescue system starts at the next reboot, and only once: reboot the server after enabling it.",
    "enable": "Enable rescue",
    "enabledNow": "Rescue is enabled: the server starts the rescue system at its next reboot.",
    "disable": "Disable rescue"
  },
  "password": {
    "title": "New root password",
    "lead": "Use it to sign in as root over SSH or in the console.",
    "label": "the root password",
    "once": "Copy it now. CloudServer does not store it and cannot show it again.",
    "saved": "I have saved it",
    "resetTitle": "Reset root password",
    "resetLead": "Sets a new random password for root on the running server. It needs the QEMU guest agent, which the provider's images include.",
    "reset": "Reset password",
    "needsRunning": "The server must be running.",
    "confirmTitle": "Reset the root password of “{{name}}”?",
    "consequenceOld": "The current root password stops working.",
    "consequenceKeys": "SSH keys keep working; the new password is shown once."
  },
  "rebuild": {
    "title": "Rebuild",
    "lead": "Installs a fresh operating system on the server. The server keeps its name, size, addresses and networks; everything on its disk is erased.",
    "image": "New operating system",
    "choose": "Choose an image…",
    "app": "{{name}} (app)",
    "current": "Now: {{image}}",
    "protected": "Rebuild protection is on. Turn it off in the actions menu first.",
    "action": "Rebuild server",
    "confirmTitle": "Rebuild “{{name}}”?",
    "consequenceData": "Everything on the server's disk is erased and cannot be recovered.",
    "consequenceImage": "{{image}} is installed; a new root password is shown once.",
    "consequenceKeep": "Name, size, IP addresses and networks stay the same.",
    "leadOwn": "Or take the server back to a saved state: the project's snapshots and backups fit when the architecture matches and the disk is big enough.",
    "groupCatalogue": "Operating systems and apps",
    "groupSnapshots": "Project snapshots",
    "groupBackups": "Backups",
    "own": "{{name}}, {{date}}",
    "ownBackup": "{{name}} (server {{server}}), {{date}}"
  },
  "changeType": {
    "title": "Change type",
    "lead": "Gives the server more or fewer vCPUs and memory. The server must be off; the change takes a few minutes.",
    "current": "Now: {{type}}, {{price}} per month",
    "mustBeOff": "Power the server off first: the type can only change while it is off.",
    "choose": "New type",
    "none": "No other type of this architecture is sold in this location.",
    "spec": "{{cores}}\u00a0vCPU · {{memory}}\u00a0GB · {{disk}}\u00a0GB",
    "diskTooSmall": "Its disk is smaller than the server's current disk.",
    "upgradeDisk": "Grow the disk as well",
    "upgradeDiskHint": "Without it, only vCPU and memory change and you can move back to a smaller type later. With it, the disk grows to the new size, and the server can never return to a type with a smaller disk.",
    "netPrices": "Monthly prices without VAT; billed by the hour.",
    "action": "Change type",
    "confirmTitle": "Change “{{name}}” to {{type}}?",
    "consequencePrice": "From now on the server costs {{price}} per month.",
    "consequenceDisk": "The disk grows: moving back to a type with a smaller disk is no longer possible.",
    "consequenceNoDisk": "The disk keeps its size, so you can move back later.",
    "consequenceOff": "The server stays off until you power it on."
  },
  "backups": {
    "title": "Automatic backups",
    "on": "On",
    "off": "Off",
    "lead": "Hetzner copies the whole disk once a day and keeps the last seven copies. Restore a copy to go back in time, or create a new server from it.",
    "price": "Costs {{percent}}\u00a0% of the server price: {{price}} per month.",
    "pricePercent": "Costs {{percent}}\u00a0% of the server price.",
    "window": "The copy is made daily between {{window}} UTC.",
    "enable": "Enable backups",
    "disable": "Disable backups",
    "disableTitle": "Disable backups of “{{name}}”?",
    "disableConsequence": "All existing backups of this server are deleted at once.",
    "snapshots": "Snapshots",
    "snapshotsLead": "A snapshot is a copy of the disk you make yourself, e.g. before an upgrade. It stays until you delete it and can be used to create new servers.",
    "snapshotPrice": "Billed by size: {{price}} per GB and month.",
    "snapshotTitle": "Create snapshot",
    "snapshotLead": "The server keeps running. For a consistent copy of a busy database, shut the server down first.",
    "description": "Description",
    "descriptionPlaceholder": "Before the upgrade to version 2",
    "descriptionHint": "So you recognize the snapshot later.",
    "snapshotCreate": "Create snapshot",
    "allImages": "All snapshots and backups of the project",
    "list": "Backups of this server",
    "listHint": "Hetzner keeps the last seven daily copies; each new one replaces the oldest. Keep a copy you need for longer as a snapshot.",
    "noneYet": "No backups yet: the first is made in the next backup window.",
    "noneOff": "Backups are off, there are none.",
    "snapshotList": "Snapshots of this server",
    "noSnapshots": "No snapshots of this server yet.",
    "disableKeep": "Backups deleted: {{count}}. Keep the one you need as a snapshot first."
  },
  "metrics": {
    "lead": "Load of the server as Hetzner measures it from outside. Values are averages over each point's interval.",
    "range": "Period",
    "ranges": {
      "1h": "1 hour",
      "24h": "24 hours",
      "7d": "7 days",
      "30d": "30 days"
    },
    "cpu": "CPU",
    "cpuLabel": "Load",
    "diskIops": "Disk operations",
    "diskBandwidth": "Disk throughput",
    "networkPps": "Network packets",
    "networkBandwidth": "Network traffic",
    "read": "Read",
    "write": "Write",
    "in": "In",
    "out": "Out",
    "empty": "No data for this period: the server was off or has only just been created.",
    "units": {
      "iops": "{{value}} IOPS",
      "pps": "{{value}} pkt/s",
      "b": "{{value}} B/s",
      "kb": "{{value}} kB/s",
      "mb": "{{value}}\u00a0MB/s",
      "gb": "{{value}}\u00a0GB/s"
    }
  },
  "delete": {
    "action": "Delete server",
    "title": "Delete server",
    "confirmTitle": "Delete “{{name}}”?",
    "consequenceData": "The server and everything on its disk are deleted for good. Backups go with it; snapshots stay.",
    "consequenceIps": "Its public IP addresses are deleted with it when their auto-delete is on (the default for addresses created with the server); the others stay in the project, unassigned.",
    "consequenceBilling": "Billing stops once the deletion has finished.",
    "protected": "Delete protection is on",
    "protectedLead": "Protection keeps the server from being deleted by mistake. Turn it off first if you really want to delete it.",
    "started": "Deleting “{{name}}”",
    "ipsTitle": "The server's public addresses",
    "ipsLead": "Checked addresses stay in the project, unassigned: you can assign them to another server in the same region later without changing DNS records. Unchecked ones are deleted with the server and cannot be brought back.",
    "keepIp": "Keep {{address}}",
    "keepIpv4Cost": "An IPv4 address is billed until it is deleted, also without a server: {{price}} per month.",
    "keepIpv4Billed": "An IPv4 address is billed monthly until it is deleted, also without a server.",
    "keepIpv6Free": "IPv6 is free.",
    "ipStays": "{{address}} stays in the project: its auto-delete is off."
  },
  "iso": {
    "title": "ISO image",
    "badge": "ISO attached",
    "lead": "An ISO image is attached to the server as a virtual CD drive: an installer of another system, a live system or a driver disk. While it is attached, the server tries to boot from it first on every start, and only then from its disk.",
    "stepAttach": "Choose an image and attach it.",
    "stepReboot": "Reboot the server: it boots from the ISO.",
    "stepConsole": "Open the console and install or do what you need.",
    "stepDetach": "Detach the ISO when you are done, or the server boots from it again.",
    "attachedNow": "\"{{name}}\" is attached. The server boots from it on its next start.",
    "reboot": "Reboot",
    "detach": "Detach ISO",
    "attachTitle": "Attach an image",
    "replaceTitle": "Replace the image",
    "choose": "Image",
    "placeholder": "Choose an image…",
    "groupOwn": "Project images",
    "groupPublic": "Shared images",
    "until": "{{name}} (available until {{date}})",
    "architecture": "Images for the server's architecture ({{arch}}) and universal ones are listed.",
    "none": "There are no ISO images for this server's architecture.",
    "replaces": "\"{{name}}\", attached now, will be detached.",
    "attach": "Attach ISO"
  },
  "appliance": {
    "label": "Managed appliance",
    "badge": "Managed appliance",
    "title": "Managed appliance. Manual changes will be overwritten.",
    "text": "The app «{{name}}» created this server and manages it. Rebuilding, another type, turning protection off or deleting it happen only through the app. The console is for diagnostics: every time it is opened goes into the audit log.",
    "drift": "Changed at the provider: {{checks}}. Put it back as it was on the app's page.",
    "checks": {
      "label": "label",
      "protection": "protection",
      "type": "type"
    },
    "open": "Open «{{name}}»",
    "onlyPackage": "Managed appliance: only through its app",
    "show": "Show managed appliances ({{count}})"
  }
}
